import * as React from 'react';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';

export type ChartCardProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
};

/**
 * Moldura comum dos gráficos do BI (Container + Header h3, altura fixa de 16 rem).
 *
 * Origem: sem issue — commit 85642b993, 2026-05-04 15:56 +0200.
 * Usado por: `BiTimeChart`, `BiPieChart` e `dashboard-product/DauWauMauChart` (`apps/admin`).
 */
export function ChartCard({ title, subtitle, children }: ChartCardProps): React.JSX.Element {
  return (
    <Container header={<Header variant="h3" description={subtitle}>{title}</Header>}>
      <div style={{ height: '16rem' }}>{children}</div>
    </Container>
  );
}
